<aside class="hit_sidebar open_sidbar sidebar-slide-push">
        <button type="button" class="btn btn-green"><span class="btn-text">GENERATE INVOICE</span></button>

        <ul>
            <li class="sidebar-title">Main</li>
            <li><a class="active" href="#"><img class="icon" src="../../../assets/icons/Vector.png">Overview</a></li>        
        
            <li class="sidebar-title">Payments</li>
            <li><a  href="#"><img class="icon" src="../../../assets/icons/account.png">All Payments</a></li>        
            <li><a  href="#"><img class="icon" src="../../../assets/icons/Vector (1).png">Reconciled Payments</a></li>        
            <li><a  href="#"><img class="icon" src="../../../assets/icons/account.png">Un - Reconciled Payments</a></li>        
            <li><a  href="#"><img class="icon" src="https://icons.getbootstrap.com/icons/bullseye.svg">Manual Settlement</a></li>        
       
            <li class="sidebar-title">Orders</li>
            <li><a  href="#"><img class="icon" src="../../../assets/icons/budget.svg">All Orders</a></li>        
            <li><a  href="#"><img class="icon" src="../../../assets/icons/Vector (1).png">Pending Orders</a></li>        
            <li><a  href="#"><img class="icon" src="../../../assets/icons/accounting.svg">Reconciled Orders</a></li>        
            <li style="margin-top: 10px"><a  href="#"><img class="icon" src="https://icons.getbootstrap.com/icons/person.svg">Merchant Profile</a></li>        
       
        </ul>
    </aside>